import { NoddiInfoBanner } from '../../../../Feedback/NoddiInfoBanner';
import { NoddiButton } from '../../../../Inputs/NoddiButton';
import type { TableFilterTranslations } from '../../tableTranslationTypes';

type Props = {
  title: string;
  isFetching: boolean;
  onRetry: () => void;
  translations: TableFilterTranslations;
};

export function FilterLoadError({ title, isFetching, onRetry, translations: texts }: Props) {
  return (
    <div role='status' aria-label={title} className='py-4'>
      <NoddiInfoBanner
        variant='error'
        size='small'
        texts={[{ value: texts.optionsLoadFailed }]}
        actionNode={
          <NoddiButton variant='secondary' size='small' loading={isFetching} onClick={onRetry}>
            {isFetching ? texts.retrying : texts.retry}
          </NoddiButton>
        }
      />
    </div>
  );
}
